var App = App || {};

App.CookieNotice = (() => {
    'use strict';

    let notice;

    const init = () => {
        notice = document.getElementById('cookie-notice');
        if (notice) {
            notice.querySelector('.cookie-notice__dismiss')
                .addEventListener('click', dismiss);
        }
    };

    const dismiss = (e) => {
        e.preventDefault();
        notice.classList.add('cookie-notice--dismissed');
        notice.addEventListener('transitionend', afterDismissed, { once: true });
        App.Cookies.setItem(
            'CookieNoticeAccepted',
            'true',
            Infinity,
            '/',
            window.location.hostname,
            window.location.protocol === 'https:'
        );
    };

    const afterDismissed = () => {
        notice.remove();
    };

    return {
        init,
    };
})();